import { ArrowUpRight } from "lucide-react";

import { Skeleton } from "@/components/ui/skeleton";

interface EntityCardProps {
  label: string;
  href?: string;
  isLoading?: boolean;
  name: string | undefined;
  id: string;
}

export function EntityCard({
  label,
  href,
  isLoading = false,
  name,
  id,
}: EntityCardProps) {
  const content = (
    <>
      <div className="flex flex-col gap-0.5 min-w-0">
        {isLoading ? (
          <Skeleton className="h-4 w-48" />
        ) : (
          <span className="truncate text-sm font-medium">{name ?? id}</span>
        )}
        <span className="font-mono text-[11px] text-muted-foreground truncate">
          {id}
        </span>
      </div>
      {href && (
        <ArrowUpRight className="h-4 w-4 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      )}
    </>
  );

  return (
    <div className="flex flex-col gap-1.5">
      <h3 className="text-xs uppercase tracking-wide text-muted-foreground">
        {label}
      </h3>
      {href ? (
        <a
          href={href}
          className="group flex items-center justify-between gap-3 rounded-md border bg-card px-3 py-2.5 transition-colors hover:bg-accent"
        >
          {content}
        </a>
      ) : (
        <div className="flex items-center justify-between gap-3 rounded-md border bg-card px-3 py-2.5">
          {content}
        </div>
      )}
    </div>
  );
}
